import React from "react";
import { css, useTheme } from "@emotion/react";

type Props = {
    children: React.ReactNode,
};

const BurgerNavLeft: React.FC<Props> = ({ children }) => {
    const theme = useTheme();

    const style = css`
        padding: 25px 0 0 55px;
        width: 50%;
        background-color: ${theme.colours.curiousBlue};
        box-shadow: ${theme.borderAndShadow.boxInsetTopShadow1};
        
        ${theme.breakpoints.down("md")} {
            display: none;
        }
    `;

    return (
        <div css={style}>
            {children}
        </div>
    );
};

export default BurgerNavLeft;